/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

export default freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/_freeGlobal.js
// module id = 1565
// module chunks = 0